import { BlockReasonQueries } from '@/graphql/queries/blockReasons.queries'
import { BlockReason, HierarchyType } from '@/types/BlockReasons'

import { useGraphql } from '../useGraphql'

export const useBlockReasons = () => {
  const { data, ...restOfQuery } = useGraphql<{ blockReasons: BlockReason[] }>(
    BlockReasonQueries.QUERY_KEY,
    BlockReasonQueries.getBlockReasons(),
  )
  const homeBlockReasons =
    data?.blockReasons.filter((reason) => reason.hierarchy === HierarchyType.HOME.toLowerCase()) || []
  const propertyBlockReasons =
    data?.blockReasons.filter((reason) => reason.hierarchy === HierarchyType.PROPERTY.toLowerCase()) || []

  return {
    data,
    ...restOfQuery,
    homeBlockReasons,
    propertyBlockReasons,
  }
}
